import Title from "../main/Title";
import AquaButton from "../main/app-download/AquaButton";
import ContactInput from "./ContactInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

// ✅ تعریف اسکیمای ولیدیشن
const schema = yup.object().shape({
  name: yup.string().required("لطفاً نام و نام خانوادگی را وارد کنید."),
  email: yup
    .string()
    .email("ایمیل وارد شده معتبر نیست.")
    .required("لطفاً ایمیل خود را وارد کنید."),
  message: yup.string().required("لطفاً پیام خود را وارد کنید."),
});

const ContactSection = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    console.log(data);
    alert("پیام شما با موفقیت ارسال شد!");
  };

  return (
    <div className="h-full">
      <h3 className="text-[20px] font-semibold text-[#383838]
      border-b border-b-[#D2D2D2] pb-4 mb-4">
        <span>با ما در </span>
        <Title text={" ارتباط "} />
        <span>باشید!</span>
      </h3>

      <form onSubmit={handleSubmit(onSubmit)}
      className="flex flex-col
      gap-3 w-full">
        <div className="w-full h-full flex gap-3">
          <ContactInput
            name="name"
            label="نام"
            type="text"
            hint="نام و نام خانوادگی"
            register={register}
            error={errors.name}
          />
          <ContactInput
            name="email"
            label="ایمیل"
            type="text"
            hint="ایمیل"
            register={register}
            error={errors.email}
          />
        </div>

        <div>
          <textarea
            {...register("message")}
            className="resize-none w-full focus:outline-none focus:ring-2
            focus:ring-aqua bg-[#e8e8e8] rounded-[10px] py-3 px-5
            placeholder:text-sm"
            rows="4"
            placeholder="پیام شما"
          ></textarea>
          {errors.message && (
            <p className="text-red-500 text-sm mt-1">
              {errors.message.message}</p>
          )}
        </div>

        <AquaButton type="submit" />
      </form>
    </div>
  );
};

export default ContactSection;
